export const addLeafletLayer =  function (){
    console.log("请求临时资源");

    var style1 = new SuperMap.REST.ServerStyle({
        fillForeColor: new SuperMap.REST.ServerColor(0, 0, 255),
        fillBackOpaque: false,
    });
    var style2 = new SuperMap.REST.ServerStyle({
        fillForeColor: new SuperMap.REST.ServerColor(0, 255, 0),
        fillBackOpaque: false
    });
    var style3 = new SuperMap.REST.ServerStyle({
        fillForeColor: new SuperMap.REST.ServerColor(255, 255, 0),
        fillBackOpaque: false
    });
    var style4 = new SuperMap.REST.ServerStyle({
        fillForeColor: new SuperMap.REST.ServerColor(255, 0, 0),
        fillBackOpaque: false
    });

    var themeUniqueIteme1 = new SuperMap.REST.ThemeUniqueItem({
        unique: "1",
        visible: true,
        style: style1
    });

    var themeUniqueIteme2 = new SuperMap.REST.ThemeUniqueItem({
        unique: "2",
        visible: true,
        style: style2
    });
    var themeUniqueIteme3 = new SuperMap.REST.ThemeUniqueItem({
        unique: "3",
        visible: true,
        style: style3
    });
    var themeUniqueIteme4 = new SuperMap.REST.ThemeUniqueItem({
        unique: "4",
        visible: true,
        style: style4
    });

    var themeUnique = new SuperMap.REST.ThemeUnique({
        uniqueExpression: "ColorID",
        items: [themeUniqueIteme1, themeUniqueIteme2, themeUniqueIteme3, themeUniqueIteme4]
    });
    themeUnique


    var themeParameters = new SuperMap.REST.ThemeParameters({
        datasetNames: ["Countries"],
        dataSourceNames: ["World"],
        joinItems: null,
        displayFilters: ['smid=1'],
        //["SmID desc", "SmArea desc"],
        displayOrderBys: ["SmID desc"],
        themes: [themeUnique]
    });


    var commit = getcommit();
    var uri = 'http://192.168.1.8:8090/iserver/services/map-ant/rest/maps/ant/tempLayersSet.json'

    var entry = getJsonParameters(themeParameters);
    commit.open("POST", encodeURI(uri), false, "", "");
    commit.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    entry = eval('('+ entry +')')
    console.log(entry);
    commit.send(entry);

    // alert(commit.responseText);
    return commit.responseText
    // var response = json_parse(commit.responseText, null);


    // //获取请求返回的layrid
    // var layersID = response.newResourceID;
    // console.log(layersID);
}
function getcommit()
{
    var commit = null;

    try{
        commit = new ActiveXObject("Msxml2.XMLHTTP");
    }catch(ex){
        try{
            commit = new ActiveXObject("Microsoft.XMLHTTP");
        }catch(ex){
            commit=null;
        }
    }
    if(!commit && typeof XMLHttpRequest != "undefined"){
        commit = new XMLHttpRequest();
    }
    return commit;
}
function getJsonParameters(parameter) {
    var jsonParameters = "",
        themeObj = null,
        filters = null,
        orderBys = null;
    jsonParameters += "[{'type': 'UGC','subLayers': {'layers': [{";
    for (var themeID in parameter.themes) {
        themeObj = parameter.themes[themeID];
        // var jsonTheme = SuperMap.Util.toJSON(themeObj);
        var jsonTheme = JSON.stringify(themeObj)
        jsonTheme.replace(/"/g,'\'')
        // jsonTheme = jsonTheme.slice(0, -1)+'}}';


        // jsonParameters += "{'theme': " + jsonTheme + "},'type': 'UGC','ugcLayerType': 'THEME',";
        jsonParameters += "'type': 'UGC','ugcLayerType': 'THEME',";
        filters = parameter.displayFilters;
        if (filters && filters.length > 0) {
            if (filters.length === 1) {
                jsonParameters += "'displayFilter':'" + filters[0] + "',";
            } else {
                jsonParameters += "'displayFilter':'" + filters[themeID] + "',";
            }
        }
        orderBys = parameter.displayOrderBys;
        if (orderBys && orderBys.length > 0) {
            if (orderBys.length === 1) {
                jsonParameters += "'displayOrderBy':'" + orderBys[0] + "',";
            } else {
                jsonParameters += "'displayOrderBy':'" + orderBys[themeID] + "',";
            }
        }

        if (parameter.joinItems && parameter.joinItems.length > 0 && parameter.joinItems[themeID]) {
            jsonParameters += "'joinItems':[" + SuperMap.Util.toJSON(parameter.joinItems[themeID]) + "],";
        }
        if (parameter.datasetNames && parameter.dataSourceNames) {
            jsonParameters += "'datasetInfo': {'name': '" + parameter.datasetNames[0] +
                "','dataSourceName': '" + parameter.dataSourceNames[0] + "'}},";
        } else {
            jsonParameters += "},";
        }
    }


    if (parameter.themes && parameter.themes.length > 0) {
        jsonParameters = jsonParameters.substring(0, jsonParameters.length - 1);
    }
    jsonParameters += "]}";

    jsonParameters += "}]";
    return jsonParameters;
}

export const addLeafletLayerFromOption =  function (url,params){
    var commit = getcommit();
    var uri = 'http://192.168.1.8:8090/iserver/services/map-ant/rest/maps/ant/tempLayersSet.json'
    uri = url
    // var entry = getJsonParameters(themeParameters);
    var entry = JSON.stringify(params)
    commit.open("POST", encodeURI(uri), false, "", "");
    commit.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    commit.send(entry);
    return commit.responseText
}